import { jsx as _jsx } from "react/jsx-runtime";
import { Container as MuiContainer, } from '@mui/material';
export const Container = ({ maxWidth = 'xl', ...props }) => {
    return _jsx(MuiContainer, { ...props, maxWidth: maxWidth });
};
